import React, { useState } from 'react';
import { Edit, SimpleForm, TextInput, FileInput, ImageField, useUpdate, useNotify, useRedirect, Toolbar, SaveButton, required, useRecordContext } from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { uploadImage } from '../../../config/services/strapi/strapi';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';

function NuestraHistoriaEdit() {
  const [update] = useUpdate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'plg-nuestra-historias';
  const record: any = useRecordContext();
  const [imageChanged, setImageChanged] = useState(false);

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');

      const payload: any = {
        anoImage: data.anoImage,
        tituloImage: data.tituloImage,
        descripcionImage: data.descripcionImage,
        titulo: data.titulo,
        descripcion: data.descripcion,
      };

      if (data.image?.rawFile) {
        const fileUploaded = await uploadImage(data.image.rawFile, token!);
        if (fileUploaded?.id) {
          payload.image = { id: fileUploaded.id };
        }
      }

      await update(resourceName, { id: data.id || record.id, data: payload }, { returnPromise: true });
      notify('Hito actualizado', { type: 'success' });
      redirect('list', resourceName);
    } catch (e: any) {
      notify(`Error: ${e.message}`, { type: 'error' });
    }
  };

  return (
    <Edit>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <TextInput source="anoImage" validate={[required()]} fullWidth />
        <TextInput source="tituloImage" validate={[required()]} fullWidth />
        <RichTextInput 
          source="descripcionImage" 
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />

        {record?.image?.url && (
          <div>
            <div>
              <img src={record.image.url} alt="Imagen actual" style={{ width: 200, height: 'auto', borderRadius: 4 }} />
            </div>
          </div>
        )}

        <FileInput source="image" label="Subir nueva imagen (opcional)" multiple={false} onChange={() => setImageChanged(true)}>
          <>
            {imageChanged ? <ImageField source="src" title="title" /> : <ImageField source="url" title="title" />}
          </>
        </FileInput>
      </SimpleForm>
    </Edit>
  );
}

export default NuestraHistoriaEdit;